import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import './/StyleComponents/Navigation.css';
import Modal from 'react-modal';

const customStyles = {
    content: {
        position:'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width:'75%',
        zIndex:'1000!important',
        border:'solid 2px white',
        borderRadius:'20px',
        background:'black',
        animation: 'none !important'

    },
};


const Navigation = () => {
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const navigate = useNavigate();

    function openModal() {
        setIsOpen(true);
    }


    function closeModal() {
        setIsOpen(false);
    }

    const handleLinkClick = (path) => {
        navigate(path);
        closeModal();
    }

    return (

        <div>
            <div className="togglerContainer">
                <Navbar.Toggle onClick={openModal} aria-controls="basic-navbar-nav" className="custom-toggler"/>
            </div>
            <Modal isOpen={modalIsOpen}
                   onRequestClose={closeModal}
                   style={customStyles}
                   contentLabel="Example Modal">
                <button className="ModalClosebutt" onClick={closeModal}><ion-icon name="close-circle-outline"></ion-icon></button>
                <ul style={{zIndex:"10"}}>
                    <li>
                        <Nav.Link className="NavLink" style={{ marginLeft: "40px" }} onClick={() => handleLinkClick("/")}>Home</Nav.Link>
                    </li>
                    <li>
                        <Nav.Link className="NavLink" style={{ marginLeft: "40px" }} onClick={() => handleLinkClick("/projects")}>Projects</Nav.Link>
                    </li>
                    <li>
                        <Nav.Link className="NavLink" style={{ marginLeft: "40px" }} onClick={() => handleLinkClick("/contact")}>Contact me</Nav.Link>
                    </li>
                </ul>
            </Modal>
        </div>
    )
}

export default Navigation;
